import { Environment } from '../app/shared/models/Environment';

const versionConfig = require('../version.json');

export const environment = {
  production: true,
  apiBaseURL: 'https://p-lraoapi-weu-app.app.p.letsreg.com/api/v1',
  participantApiBaseURL: 'https://p-lrapapi-weu-app.app.p.letsreg.com/api/v1',
  oldApiBaseURL: 'https://legacyapi.deltager.no/api/v1',
  paymentApiURL: 'https://payment.deltager.no',
  authApiURL: 'https://auth.deltager.no',
  tokenUrl: 'https://legacyapi.deltager.no/token',
  paymentCallBackURL: '/participant/ApiPaymentReturn.aspx',
  staticAssetLocation: 'https://deltagerfiles.blob.core.windows.net/assets',
  fileStorageUrl: 'https://deltagerfiles.blob.core.windows.net',
  version: versionConfig.version,
  googlePlacesApiUrl: 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&loading=async&key=',
  googlePlacesApiKey: 'AIzaSyAvEaxFogrvoI6lHDKzGy6X77j38tRMLA8',
  env: Environment.Prod,
  eventsListRelativeUrl: '/arrangement/listarrangements.aspx?com=2',
  defaultAffiliateId: 0,
  cmsHeadlessUrl: 'https://www.letsreg.com/no/headless',
  configCatKey: 'configcat-sdk-1/ytvdCDt_dU2NcDIkM5mfXw/m5pje4XHYEOjg3idEYaX7A',
};
